import React from "react";
import styled from "styled-components";
import { Delete } from "@mui/icons-material";
import { useTable } from "react-table";
import { useAppDispatch, useAppSelector } from "../../app/store/configureStore";
import {
  entrezDbSelectors,
  updateSelectedDBState,
} from "../../app/store/entrezDbSlice";
import { queryTermFormatter } from "../../app/util/util";

import { Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import FullScreenTableView from "./FullScreenTableView";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  TextField,
  Grid,
  Box,
} from "@mui/material";
import FinalSearchOperationView from "./FinalSearchOperationView";

const Styles = styled.div`
  padding: 1rem;
  table {
    // to hide the header row which is being added by react-table.
    thead tr:first-child {
      display: none;
      // background-color: red;
    }
  }

  .form-control {
    min-width: 100%;
    max-width: 100%;
  }

  .pagination {
    padding: 1rem;
  }
`;

// Create an editable cell renderer
const EditableCell = ({
  value: initialValue,
  row: { index },
  column: { id },
  updateMyData, // This is a custom function that we supplied to our table instance
}) => {
  // We need to keep and update the state of the cell normally
  const [value, setValue] = React.useState(initialValue);

  const onChange = (e) => {
    setValue(e.target.value);
  };

  // We'll only update the external data when the input is blurred
  const onBlur = () => {
    updateMyData(index, id, value);
  };

  // If the initialValue is changed external, sync it up with our state
  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return (
    <TextField
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      fullWidth
      variant="outlined"
      sx={{ minWidth: 200 }}
    />
  );
};

// Set our editable cell renderer as the default Cell renderer
const defaultColumn = {
  Cell: EditableCell,
};

// Be sure to pass our updateMyData and the skipPageReset option
function EditableTable({
  columns,
  data,
  updateMyData,
  skipPageReset,
  onRemoveQueryItem,
}) {
  const [open, setOpen] = React.useState(true);
  const toggleView = () => {
    setOpen(!open);
  };

  // For this example, we're using pagination to illustrate how to stop
  // the current page from resetting when our data changes
  // Otherwise, nothing is different here.
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
      defaultColumn,
      // use the skipPageReset option to disable page resetting temporarily
      autoResetPage: !skipPageReset,
      // updateMyData isn't part of the API, but
      // anything we put into these options will
      // automatically be available on the instance.
      // That way we can call this function from our
      // cell renderer!
      updateMyData,
    });

  // Render the UI for your table
  return (
    <>
      <Box display="flex" alignItems="center">
        {/* <Container maxWidth="lg"> */}
        <Grid container spacing={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            {/* Search Term - 1*/}
            {open && (
              <TableContainer>
                <Table
                  className="table1"
                  sx={{ tableLayout: "auto", size: "small" }}
                  {...getTableProps()}
                >
                  <TableHead
                    sx={
                      {
                        // backgroundColor: "primary.main",
                        // color:"black"
                      }
                    }
                  >
                    {headerGroups.map((headerGroup) => (
                      <TableRow {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <TableCell {...column.getHeaderProps()}>
                            <Typography variant="subtitle2">
                              {column.render("Header")}
                            </Typography>
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableHead>
                  <TableBody {...getTableBodyProps()}>
                    {rows.map((row, i) => {
                      prepareRow(row);
                      return (
                        <TableRow
                          style={{
                            height: 10,
                          }}
                          {...row.getRowProps()}
                         /* sx={{
                            "&:hover": {
                              backgroundColor: "#d9d9d9",
                            },
                          }}*/
                        >
                          {row.cells.map((cell) => {
                            var isDelete = cell.column.Header === "Delete";
                            var isterm = cell.column.Header === "Query Terms";
                            var getWidth = isterm ? 1000 : 20;
                            return (
                              <TableCell
                                sx={{ width: getWidth }}
                                {...cell.getCellProps()}>
                              
                                {isterm && 
                                cell.render("Cell")}

                                {!isterm && !isDelete && (
                                  <Typography variant="body2">
                                    {cell.value}
                                  </Typography>
                                )}

                                {isDelete && (
                                  <Button
                                    color="error"
                                    onClick={() => {
                                      onRemoveQueryItem(i);
                                    }}
                                  >
                                    <Delete />
                                  </Button>
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Grid>

          {/* fullWidth -4 */}
      
          <Grid item lg={8} md={8} sm={12} xs={12}>
            {/* <Title>Final Query</Title> */}
            {/* <Button onClick={toggleView}>AFk you</Button> */}
            <Box display="flex" flexDirection="row" alignItems="left">
            <IconButton
              sx={{ backgroundColor: "primary.main" , mr:3, maxHeight:35 ,mt:0}}
              onClick={toggleView}
            >
             {open && (<ArrowUpwardIcon />)}
             {!open && (<ArrowDownwardIcon />)}
            </IconButton>
<FullScreenTableView></FullScreenTableView>
</Box>
          </Grid>
         

          <Grid item lg={4} md={4} sm={12} xs={12}>
            {/* <Title>Final Query</Title> */}
            <FinalSearchOperationView></FinalSearchOperationView>
          </Grid>
        </Grid>

        {/* </Container> */}
      </Box>
    </>
  );
}

export default function QueryTableEditable() {
  const columns = React.useMemo(
    () => [
      {
        Header: "Query Terms",
        columns: [
          {
            Header: "Query Terms",
            accessor: "term",
          },
          {
            Header: "Operator",
            accessor: "op",
          },
          // {
          //   Header: "Field",
          //   accessor: "field",
          // },
          {
            Header: "Delete",
            accessor: "delete",
          },
        ],
      },
    ],
    []
  );

  const { dbParams } = useAppSelector((state) => state.entrezDb);
  const dispatch = useAppDispatch();

  const selectedDbWithItsState = useAppSelector((state) =>
    entrezDbSelectors.selectById(state, dbParams.db)
  );

  const handleOnRemoveQueryItem = (index) => {
    console.log("handleOnRemoveQueryItem: " + index);

    if (index < 0) return;

    var queriesCopyToUpdate = [...selectedDbWithItsState.queryFields];

    queriesCopyToUpdate.splice(index, 1);

    const formattedQueryTerm = queryTermFormatter(queriesCopyToUpdate);
    //{ id: 'a', changes: { title: 'First (altered)' } }
    dispatch(
      updateSelectedDBState({
        id: dbParams.db,
        changes: {
          queryFields: queriesCopyToUpdate,
          finalFormattedSearchTerm: formattedQueryTerm,
        },
      })
    );
  };

  const [data, setData] = React.useState(() => {
    const queries = selectedDbWithItsState?.queryFields;
    return queries;
  });
  const [originalData] = React.useState(data);
  const [skipPageReset, setSkipPageReset] = React.useState(false);

  // We need to keep the table from resetting the pageIndex when we
  // Update data. So we can keep track of that flag with a ref.

  // When our cell renderer calls updateMyData, we'll use
  // the rowIndex, columnId and new value to update the
  // original data
  const updateMyData = (rowIndex, columnId, value) => {
    // We also turn on the flag to not reset the page
    setSkipPageReset(true);

    setData((old) =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          };
        }
        return row;
      })
    );
  };

  // me
  React.useEffect(() => {
    setData(selectedDbWithItsState?.queryFields);
  }, [selectedDbWithItsState?.queryFields]);

  React.useEffect(() => {
    console.log(data);
    // const filteredQueries = selectedDbWithItsState.queryFields.filter(
    //   (qItem) => qItem.field !== fieldName
    // );

    const formattedQueryTerm = queryTermFormatter(data);
    //{ id: 'a', changes: { title: 'First (altered)' } }
    dispatch(
      updateSelectedDBState({
        id: dbParams.db,
        changes: {
          queryFields: data,
          finalFormattedSearchTerm: formattedQueryTerm,
        },
      })
    );
  }, [data]);

  // After data chagnes, we turn the flag back off
  // so that if data actually changes when we're not
  // editing it, the page is reset
  React.useEffect(() => {
    setSkipPageReset(false);
  }, [data]);

  // Let's add a data resetter/randomizer to help
  // illustrate that flow...
  const resetData = () => setData(originalData);

  return (
    <Styles>
      {/* <button onClick={resetData}>Reset Data</button> */}
      <EditableTable
        columns={columns}
        data={data}
        updateMyData={updateMyData}
        skipPageReset={skipPageReset}
        onRemoveQueryItem={handleOnRemoveQueryItem}
      />
    </Styles>
  );
}
